// src/services/apiClient.ts
import axios from "axios";
import { baseApiURL } from "./baseApiUrl";
import { getRawToken, getToken } from "../utils/tokenFunctions";

export const apiClient = axios.create({
  baseURL: baseApiURL,
  headers: { "Content-Type": "application/json" },
});

// Interceptor para inyectar siempre el access token
apiClient.interceptors.request.use((config) => {
  let token = getToken(); // solo access token

  if(!token) {
    console.warn("apiClient: No se encontró token de autorización");
    token = getRawToken(); // intentar raw token (LTI mode)
  }

  if (token && config.headers) {
    config.headers["Authorization"] = `Bearer ${token}`;
  } else {
    console.warn("apiClient: Request sin token Authorization", {
      url: (config.baseURL ?? "") + config.url,
    });
  }

  return config;
});
